import { mapGetters } from "vuex";

export default {
    computed: mapGetters({
        user: 'auth/user'
    }),
    data: () => ({
        menuItems: [],
    }),
    created () {
        if (!this.user) return []
        this.menuItems = [
            {
                icon: 'dashboard',
                label: 'dashboard',
                route: 'home',
                market: ['*']
            },

            // Backoffice
            {
                label: 'lending points',
                icon: 'store',
                route: 'backoffice.lending-point.index',
                widget: true,
                role: ['Admin', 'Backoffice'],
                market: ['*'],
                highlight: this.user && this.user.hasOwnProperty('highlight_lending_point_menu') ?
                    this.user.highlight_lending_point_menu : false
            },
            {
                label: 'Solucionador de Problemas',
                icon: 'lightbulb',
                route: 'admin.problem-fixer.index',
                widget: true,
                role: ['Admin', 'Backoffice'],
                market: ['*']
            },
            {
                label: 'orders',
                icon: 'shopping cart',
                route: 'backoffice.order.index',
                widget: true,
                role: ['Admin', 'Backoffice'],
                market: ['*']
            },
            {
                label: 'lending kits',
                icon: 'how to vote',
                route: 'backoffice.lending-kit.index',
                widget: true,
                role: ['Admin', 'Backoffice', 'Courier', 'Call Center', 'Logista'],
                market: ['*']
            },

            {
                label: 'stock movements',
                icon: 'inventory',
                route: 'backoffice.stock-movement.index',
                widget: true,
                role: ['Admin', 'Backoffice'],
                market: ['*']
            },
            {
                label: 'order movements',
                icon: 'swap horiz',
                route: 'backoffice.order-movement.index',
                widget: true,
                role: ['Admin', 'Backoffice'],
                market: ['*']
            },

            {
                label: 'partners',
                icon: 'store',
                route: 'backoffice.partner.index',
                widget: true,
                role: ['Admin', 'Backoffice'],
                market: ['*']
            },

            // Call Center
            // {
            //     label: 'create a new lending order',
            //     icon: 'note add',
            //     route: 'call-center.order',
            //     widget: true,
            //     role: 'Call Center',
            // },
            {
                label: 'orders history',
                subtitle: 'view your loan history',
                icon: 'fa icon-info',
                route: 'call-center.orders',
                widget: true,
                role: ['Call Center'],
                market: ['*']
            },
            {
                label: 'due orders',
                icon: 'alarm off',
                route: 'call-center.orders.due',
                widget: true,
                role: 'Call Center',
                market: ['*']
            },
            {
                label: 'lendings that will due',
                icon: 'alarm',
                route: 'call-center.orders.will-due',
                widget: true,
                role: 'Call Center',
                market: ['*']
            },
            {
                label: 'orders closed before lending end',
                icon: 'history',
                route: 'call-center.orders.closed-earlier',
                widget: true,
                role: 'Call Center',
                market: ['*']
            },
            // {
            //     label: 'consumer registration',
            //     icon: 'face',
            //     route: 'call-center.consumer-registration',
            //     widget: true,
            //     role: 'Call Center',
            // },

            // Courier/Call Center
            {
                label: 'lending points stock',
                icon: 'local_shipping',
                route: 'lending-points.stock',
                widget: true,
                role: ['Courier'],
                market: ['*']
            },

            // Lending Point
            {
                label: 'create a new lending order',
                subtitle: 'register the lending',
                icon: 'fa icon-prestamos',
                route: 'lending-point.order',
                widget: true,
                role: ['Lending Point'],
                market: ['*']
            },
            {
                label: 'orders history',
                subtitle: 'view your loan history',
                icon: 'fa icon-info',
                route: 'lending-point.orders',
                widget: true,
                role: ['Lending Point'],
                market: ['*']
            },
            {
                label: 'orders in lending',
                subtitle: 'select the way to finalize the loan',
                icon: 'fa icon-success',
                route: 'lending-point.orders.in-lending',
                widget: true,
                role: ['Lending Point'],
                market: ['*']
            },
            {
                label: 'lending kits stock',
                subtitle: 'check the stock status of your kits',
                icon: 'fa icon-kit',
                route: 'lending-point.lending-kits',
                widget: true,
                role: ['Lending Point'],
                market: ['*']
            },
            {
                 label: 'add new lending kit',
                 icon: 'fa icon-info',
                 route: 'lending-point.lending-kits.add',
                 widget: true,
                 role: ['Lending Point', 'Backoffice', 'Sales Expert', 'MUPI', 'Remote Coach'],
                 market: ['*']
            },
            {
                label: 'devices sanitization',
                subtitle: 'sanitize returned devices',
                icon: 'fa icon-limpieza',
                route: 'lending-point.clear',
                widget: true,
                role: ['Lending Point'],
                market: ['*']
            },
            // {
            //     label: 'lending kits for maintenance',
            //     icon: 'phonelink_setup',
            //     route: 'lending-point.lending-kits.cleaning',
            //     widget: true,
            //     role: 'Lending Point',
            // },

            // Courier
            {
                label: 'orders history',
                subtitle: 'view your loan history',
                icon: 'fa icon-info',
                route: 'courier.orders',
                widget: true,
                role: 'Courier',
                market: ['*']
            },
            /*{
                label: 'delivery orders',
                icon: 'star',
                route: 'courier.orders.reserved',
                widget: true,
                role: 'Courier',
                market: ['*']
            },
            {
                label: 'in transit',
                icon: 'motorcycle',
                route: 'courier.orders.in-transit',
                widget: true,
                role: 'Courier',
                market: ['*']
            },
            {
                label: 'pending pickup orders',
                icon: 'undo',
                route: 'courier.orders.pending-pickup',
                widget: true,
                role: 'Courier',
                market: ['*']
            },*/
            {
                label: 'lending kits stock',
                subtitle: 'check the stock status of your kits',
                icon: 'fa icon-kit',
                route: 'courier.lending-kits',
                widget: true,
                role: 'Courier',
                market: ['*']
            },
            // {
            //     label: 'lending kits for maintenance',
            //     icon: 'phonelink_setup',
            //     route: 'courier.lending-kits.cleaning',
            //     widget: true,
            //     role: 'Courier',
            // },

            //Sales Expert
            {
                label: 'create a new lending order',
                subtitle: 'register the lending',
                icon: 'fa icon-prestamos',
                route: 'sales-expert.order',
                widget: true,
                role: ['Sales Expert', 'MUPI', 'Remote Coach'],
                market: ['*']
            },
            {
                label: 'orders history',
                subtitle: 'view your loan history',
                icon: 'fa icon-info',
                route: 'sales-expert.orders',
                widget: true,
                role: ['Sales Expert', 'MUPI', 'Remote Coach'],
                market: ['*']
            },
            {
                label: 'orders in lending',
                subtitle: 'select the way to finalize the loan',
                icon: 'fa icon-success',
                route: 'sales-expert.orders.in-lending',
                widget: true,
                role: ['Sales Expert', 'MUPI', 'Remote Coach'],
                market: ['*']
            },
            {
                label: 'lending kits stock',
                subtitle: 'check the stock status of your kits',
                icon: 'fa icon-kit',
                route: 'sales-expert.lending-kits',
                widget: true,
                role: ['Sales Expert', 'MUPI', 'Remote Coach'],
                market: ['*']
            },
            {
                label: 'devices sanitization',
                subtitle: 'sanitize returned devices',
                icon: 'fa icon-limpieza',
                route: 'sales-expert.clear',
                widget: true,
                role: ['Sales Expert', 'MUPI', 'Remote Coach'],
                market: ['*']
            },
            {
                label: 'external return',
                icon: 'assignment_return',
                route: 'lending-point.orders.external-return',
                widget: true,
                role: ['Lending Point', 'Remote Coach', 'Sales Expert', 'MUPI'],
                market: ['*']
            },
            {
                label: 'kit reservation at POS',
                icon: 'book',
                route: 'lending-point.orders.reservation',
                widget: true,
                hasChip: true,
                role: ['Lending Point', 'Sales Expert', 'MUPI', 'Remote Coach'],
                market: ['*']
            },
            {
                label: 'kit reservation at POS',
                icon: 'book',
                route: 'remote-coach.reservation',
                widget: true,
                role: [''],
                market: ['*']
            },
            {
                label: 'confirm delivery',
                subtitle: 'confirm that you have received kits',
                icon: 'fa icon-cart',
                route: 'lending-point.lending-kits.pending-reception',
                widget: true,
                role: ['Lending Point', 'Sales Expert', 'MUPI', 'Remote Coach'],
                market: ['*']
            },

            // Admin
            {
                label: 'reference tables', 
                icon: 'format_list_numbered', 
                role: ['Admin', 'BackOffice'],
                children: [
                    {
                        label: 'lending point types',
                        icon: 'place',
                        route: 'admin.lending-point-type.index',
                        widget: true,
                        role: 'Admin',
                        market: ['*']
                    },
                    {
                        label: 'consumer types',
                        icon: 'people',
                        route: 'admin.consumer-type.index',
                        widget: true,
                        role: 'Admin',
                        market: ['*']
                    },
                    {
                        label: 'lending point traces',
                        icon: 'people',
                        route: 'admin.lending-point-trace.index',
                        widget: true,
                        role: 'Admin',
                        market: ['*']
                    },
                    {
                        label: 'no sold reasons',
                        icon: 'not_interested',
                        route: 'admin.no-sold-reason.index',
                        widget: true,
                        role: 'Admin',
                        market: ['*']
                    },
                    {
                        label: 'order statuses',
                        icon: 'label',
                        route: 'admin.order-status.index',
                        widget: true,
                        role: 'Admin',
                        market: ['*']
                    },
                    {
                        label: 'owners',
                        icon: 'label',
                        route: 'admin.owner.index',
                        widget: true,
                        role: 'Admin',
                        market: ['*']
                    },
                    /*{
                        label: 'origins',
                        icon: 'input',
                        route: 'admin.origin.index',
                        widget: true,
                        role: ['Admin', 'Backoffice']
                    },*/
                    {
                        label: 'stock statuses',
                        icon: 'archive',
                        route: 'admin.stock-status.index',
                        widget: true,
                        role: 'Admin',
                        market: ['*']
                    },
                    {
                        label: 'product models',
                        icon: 'format_shapes',
                        route: 'backoffice.product-model.index',
                        widget: true,
                        role: ['Admin', 'Backoffice'],
                        market: ['*']
                    },
                    {
                        label: 'product colors',
                        icon: 'color_lens',
                        route: 'backoffice.product-color.index',
                        widget: true,
                        role: ['Admin'],
                        market: ['*']
                    },
                    {
                        label: 'order finalization modes',
                        icon: 'fa icon-cart',
                        route: 'backoffice.order-finalization-mode.index',
                        widget: true,
                        role: ['Admin', 'Backoffice'],
                        market: ['ES']
                    },

                    {
                        label: 'lending point categories',
                        icon: 'place',
                        route: 'backoffice.lending-point-category.index',
                        widget: true,
                        role: ['Admin','Backoffice'],
                        market: ['*']
                    },
                    {
                        label: 'segmentation',
                        icon: 'place',
                        route: 'backoffice.segmentation.index',
                        widget: true,
                        role: ['Admin','Backoffice'],
                        market: ['*']
                    },
                    {
                        label: 'sanitization type',
                        icon: 'place',
                        route: 'backoffice.sanitization-type.index',
                        widget: true,
                        role: ['Admin','Backoffice'],
                        market: ['*']
                    }
                ]
            },
            {
                label: 'adminstrative tools',
                icon: 'security',
                role: ['Admin', 'BackOffice'],
                children: [
                    {
                        label: 'roles',
                        icon: 'pan_tool',
                        route: 'admin.role.index',
                        widget: true,
                        role: 'Admin',
                        market: ['*']
                    },
                    {
                        label: 'users',
                        icon: 'people',
                        route: 'admin.user.index',
                        widget: true,
                        role: ['Admin', 'Backoffice'],
                        market: ['*']
                    },
                    {
                        label: 'configuration',
                        icon: 'settings',
                        route: 'admin.configuration.index',
                        widget: true,
                        role: ['Admin', 'Backoffice'],
                        market: ['*']
                    },
                    /*{
                        label: 'audit',
                        icon: 'lock',
                        route: 'admin.audit.index',
                        widget: true,
                        widgetType: 'line',
                        role: 'Admin',
                        market: ['*']
                    },*/
                    {
                        //NOTE: Item markets
                        label: 'markets',
                        icon: 'public',
                        route: 'admin.market.index',
                        widget: true,
                        role: 'Admin',
                        //To prohibit displaying the item to a market, include its abbreviation. For all markets, use *
                        market: ['AD'],
                    },
                    {
                        label: 'configuration market',
                        icon: 'settings',
                        route: 'admin.configuration-market.index',
                        widget: true,
                        trash: false,
                        role: ['Admin', 'Backoffice'],
                        market: ['*']
                    },
                    {
                        label: 'terms and conditions',
                        icon: 'format_size',
                        route: 'admin.template.index',
                        widget: true,
                        trash: false,
                        role: ['Admin', 'Backoffice'],
                        market: ['*']
                    },
                    {
                        label: 'IMDL roles',
                        icon: 'settings',
                        route: 'admin.imdl-market-roles.index',
                        widget: true,
                        role: ['Admin'],
                        market: ['*']
                    },
                    {
                        label: 'Notifications',
                        icon: 'mail',
                        route: 'admin.product-notification.index',
                        widget: true,
                        role: ['Admin', 'Backoffice'],
                        market: ['*']
                    }
                ]
            }
        ]
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/menuItems.js